import React from 'react';
import { Card, Descriptions, Space, Tag } from 'antd';
import { useTranslation } from '../../hooks/useTranslation';
import type { GetAppointmentQuery } from '../../generated/graphql';

export interface AppointmentQuestionnaireResponseSectionProps {
  appointment: GetAppointmentQuery['appointment'] | any;
}

const AppointmentQuestionnaireResponseSection: React.FC<AppointmentQuestionnaireResponseSectionProps> = ({ appointment }) => {
  const { t } = useTranslation();

  const questionnaire = (appointment as any)?.questionnaire || {};

  const shouldRender = Boolean(
    questionnaire.chief_complaint ||
      (questionnaire.symptoms && questionnaire.symptoms.length > 0) ||
      questionnaire.symptom_duration ||
      questionnaire.symptom_severity ||
      questionnaire.previous_treatment ||
      typeof appointment?.medical_history_reviewed === 'boolean' ||
      (questionnaire.allergies_noted && questionnaire.allergies_noted.length > 0) ||
      (questionnaire.medications_current && questionnaire.medications_current.length > 0) ||
      appointment?.diagnosis ||
      appointment?.treatment_plan ||
      appointment?.prescription ||
      typeof appointment?.follow_up_required === 'boolean' ||
      appointment?.follow_up_date
  );

  if (!shouldRender) return null;

  return (
    <Card title={t('appointments.medicalInformation')} style={{ marginBottom: 24 }}>
      <Descriptions column={1} size="small">
        {questionnaire.chief_complaint && (
          <Descriptions.Item label={t('appointments.chiefComplaint')}>
            {questionnaire.chief_complaint}
          </Descriptions.Item>
        )}
        {questionnaire.symptom_duration && (
          <Descriptions.Item label={t('appointments.symptomDuration') || 'Symptom Duration'}>
            {questionnaire.symptom_duration}
          </Descriptions.Item>
        )}
        {questionnaire.symptom_severity && (
          <Descriptions.Item label={t('appointments.symptomSeverity') || 'Symptom Severity'}>
            {questionnaire.symptom_severity}
          </Descriptions.Item>
        )}
        {questionnaire.symptoms && questionnaire.symptoms.length > 0 && (
          <Descriptions.Item label={t('appointments.symptoms')}>
            <Space wrap>
              {questionnaire.symptoms.map((symptom: string, index: number) => (
                <Tag key={index} color="blue">{symptom}</Tag>
              ))}
            </Space>
          </Descriptions.Item>
        )}
        {questionnaire.previous_treatment && (
          <Descriptions.Item label={t('appointments.previousTreatment') || 'Previous Treatment'}>
            {questionnaire.previous_treatment}
          </Descriptions.Item>
        )}
        {/* {typeof appointment.medical_history_reviewed === 'boolean' && (
          <Descriptions.Item label={t('appointments.medicalHistoryReviewed') || 'Medical History Reviewed'}>
            <Tag color={appointment.medical_history_reviewed ? 'green' : 'default'}>
              {appointment.medical_history_reviewed ? (t('common.yes') || 'Yes') : (t('common.no') || 'No')}
            </Tag>
          </Descriptions.Item>
        )} */}
        {questionnaire.allergies_noted && questionnaire.allergies_noted.length > 0 && (
          <Descriptions.Item label={t('appointments.allergiesNoted') || 'Allergies Noted'}>
            <Space wrap>
              {questionnaire.allergies_noted.map((allergy: string, idx: number) => (
                <Tag key={idx} color="red">{allergy}</Tag>
              ))}
            </Space>
          </Descriptions.Item>
        )}
        {questionnaire.medications_current && questionnaire.medications_current.length > 0 && (
          <Descriptions.Item label={t('appointments.currentMedications') || 'Current Medications'}>
            <Space wrap>
              {questionnaire.medications_current.map((med: string, idx: number) => (
                <Tag key={idx} color="purple">{med}</Tag>
              ))}
            </Space>
          </Descriptions.Item>
        )}
        {/* {appointment.diagnosis && (
          <Descriptions.Item label={t('appointments.diagnosis') || 'Diagnosis'}>
            {appointment.diagnosis}
          </Descriptions.Item>
        )}
        {appointment.treatment_plan && (
          <Descriptions.Item label={t('appointments.treatmentPlan') || 'Treatment Plan'}>
            {appointment.treatment_plan}
          </Descriptions.Item>
        )}
        {appointment.prescription && (
          <Descriptions.Item label={t('appointments.prescription') || 'Prescription'}>
            {appointment.prescription}
          </Descriptions.Item>
        )}
        {typeof appointment.follow_up_required === 'boolean' && (
          <Descriptions.Item label={t('appointments.followUpRequired') || 'Follow-up Required'}>
            <Tag color={appointment.follow_up_required ? 'blue' : 'default'}>
              {appointment.follow_up_required ? (t('common.yes') || 'Yes') : (t('common.no') || 'No')}
            </Tag>
          </Descriptions.Item>
        )}
        {appointment.follow_up_date && (
          <Descriptions.Item label={t('appointments.followUpDate') || 'Follow-up Date'}>
            {dayjs(appointment.follow_up_date).format('MMM DD, YYYY')}
          </Descriptions.Item>
        )} */}
      </Descriptions>
    </Card>
  );
};

export default AppointmentQuestionnaireResponseSection; 